var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C5.77909 0 5.6 0.179086 5.6 0.4V4.852C5.6 5.26511 5.26511 5.6 4.852 5.6H0.399999C0.179085 5.6 0 5.77909 0 6C0 6.22091 0.179086 6.4 0.4 6.4H4.852C5.26511 6.4 5.6 6.73489 5.6 7.148V11.6C5.6 11.8209 5.77909 12 6 12C6.22091 12 6.4 11.8209 6.4 11.6V7.148C6.4 6.73489 6.73489 6.4 7.148 6.4H11.6C11.8209 6.4 12 6.22091 12 6C12 5.77909 11.8209 5.6 11.6 5.6H7.148C6.73489 5.6 6.4 5.26511 6.4 4.852V0.399999C6.4 0.179085 6.22091 0 6 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/zoomOutIcon.67fa26d637387d002a06b1c08f4ad5ed.svg";
export { ForwardRef as ReactComponent };